/**
 * Connection presets for MDM runs.
 *
 * These are loaded from the backend at GET /api/v2/mdm/connection-presets
 * (served from mdm/config/mdm-connections.yaml). The static array below
 * is a fallback used when the API is unavailable.
 *
 * To add presets: edit mdm/config/mdm-connections.yaml in the backend repo
 * (or this array for local-only setups).
 */

// Re-export the canonical type from types.ts so callers import from one place
export type { ConnectionPreset } from "../types";

import type { ConnectionPreset } from "../types";

/**
 * Static fallback presets — shown when the API call to /connection-presets
 * fails or returns an empty list. The API is authoritative at runtime.
 */
export const CONNECTION_PRESETS: ConnectionPreset[] = [
  // Example preset — remove or replace with real values:
  // {
  //   alias: 'Customer CRM (Prod)',
  //   db_type: 'postgres',
  //   host: 'crm-prod.internal',
  //   port: 5432,
  //   database: 'crm',
  //   schema_name: 'public',
  //   username: 'mdm_reader',
  //   table_or_query: 'customers',
  //   entity_type_hint: 'person',
  // },
];
